import React from 'react';
import * as enums from '@local/finsera-core/src/enums';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import RelaxOrder from './relax-order';
import NumericField from '../../numeric-field';

type MaximumTurnoverProps = {
  params: types.optimizer.MaximumTurnoverDraft;
  setParams: (_params: types.optimizer.MaximumTurnoverDraft) => void;
  readOnly: boolean;
  validationDef: types.common.ValidationErrors;
};

const MaximumTurnover = ({ params, setParams, readOnly, validationDef }: MaximumTurnoverProps) => {
  return (
    <mui.core.Box p={2}>
      <mui.core.Grid container spacing={4}>
        <mui.core.Grid size={{ xs: 12, md: 4 }}>
          <NumericField
            textFieldProps={{
              label: 'Maximum Turnover per Period (%)',
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              required: true,
              error: validationDef?.fields?.includes('maximum_turnover_per_period'),
            }}
            disabled={readOnly}
            value={params.upper_bound}
            setValue={(v) => setParams({ ...params, upper_bound: v })}
            suffix="%"
            dividerOption={enums.NUMBER_FORMATTERS_ENUM.HUNDRED}
          />
        </mui.core.Grid>

        <mui.core.Grid size={{ xs: 12, md: 4 }}>
          <RelaxOrder params={params} setParams={setParams} disabled={readOnly} />
        </mui.core.Grid>
      </mui.core.Grid>
    </mui.core.Box>
  );
};

export default MaximumTurnover;
